import { useState } from "react";
import api from "../../api";

export default function CustomerGetImg() {
  const [chapterNumber, setChapterNumber] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hoveredHotspot, setHoveredHotspot] = useState(null);

  const backendBase = process.env.REACT_APP_BASE_URL; 
  // static folder where images are served

  const buildImageUrl = (fileName) =>
    fileName ? `${backendBase}/${fileName}` : "";

  // Fetch chapter → only IMAGE_WITH_HOTSPOTS
  const fetchImages = async () => {
    if (!chapterNumber) return;

    setLoading(true);
    setError(null);

    try {
      console.log("Fetching chapter with number:", chapterNumber);

      // ✅ no need to manually attach Authorization header
      const res = await api.get(`/admins/chapter/${chapterNumber}`);

      console.log("Full response data:", res.data);

      const chapter = res.data;
      console.log("Chapter data received:", chapter);

      const hotspotsImages =
        chapter.subChapters?.filter(
          (s) => s.contentType === "IMAGE_WITH_HOTSPOTS"
        ) || [];

      console.log("Filtered hotspot images:", hotspotsImages);

      setImages(hotspotsImages);
    } catch (err) {
      console.error("Failed to fetch images:", err);
      setError("Failed to load chapter data");
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  // Convert backend coordinate string → [x, y] as numbers
  const parseCoordinates = (coordStr) => {
    try {
      const arr = JSON.parse(coordStr); // backend stores as '["0.42","0.58"]'
      return arr.map(Number);
    } catch {
      return [];
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center text-primary">
        Customer: View Hotspot Images
      </h2>

      {/* Input for Chapter Number */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-center">
            <div className="col-md-8">
              <input
                type="number"
                className="form-control"
                placeholder="Enter Chapter Number"
                value={chapterNumber}
                onChange={(e) => setChapterNumber(e.target.value)}
              />
            </div>
            <div className="col-md-4 text-end">
              <button
                className="btn btn-primary w-100"
                onClick={fetchImages}
                disabled={loading}
              >
                {loading ? "Loading..." : "Get Hotspot Images"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && <div className="alert alert-danger text-center">{error}</div>}

      {/* Images + Hotspots */}
      <section>
        <h4 className="mb-3">Hotspot Images</h4>
        <div className="row g-4">
          {images.length === 0 ? (
            <div className="col-12">
              <div className="alert alert-warning text-center">
                No hotspot images found.
              </div>
            </div>
          ) : (
            images.map((img) => (
              <div className="col-md-6 col-lg-4" key={img.id}>
                <div className="card shadow-sm h-100">
                  <div className="card-body">
                    {/* Title */}
                    <h5 className="card-title">
                      {img.subchapterTitle || `Image #${img.id}`}
                    </h5>

                    {/* Image + Hotspots */}
                    <div
                      className="position-relative d-inline-block"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <img
                        src={buildImageUrl(img.content)}
                        alt={img.subchapterTitle}
                        className="img-fluid rounded"
                        style={{
                          cursor: "pointer",
                          display: "block",
                          width: "100%",
                        }}
                      />

                      {/* Hotspot Overlays */}
                      {img.hotspots?.map((h) => {
                        const [x, y] = parseCoordinates(h.coordinates);
                        if (x == null || y == null) return null;

                        return (
                          <div
                            key={h.id}
                            className="position-absolute bg-danger border border-white rounded-circle"
                            style={{
                              left: `${x * 100}%`,
                              top: `${y * 100}%`,
                              transform: "translate(-50%, -50%)",
                              width: "14px",
                              height: "14px",
                              cursor: "pointer",
                              zIndex: 2,
                            }}
                            onMouseEnter={() =>
                              setHoveredHotspot({ ...h, parentId: img.id })
                            }
                            onMouseLeave={() => setHoveredHotspot(null)}
                          >
                            {/* Tooltip */}
                            {hoveredHotspot?.id === h.id &&
                              hoveredHotspot?.parentId === img.id && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "-35px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    background: "black",
                                    color: "white",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    fontSize: "0.8rem",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <b>
                                    {h.label ||
                                      `Hotspot ${h.hotspotNumber || "?"}`}
                                  </b>
                                  : {h.content || "No data"}
                                </div>
                              )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
